import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import styles from '../../styles/styles.js';
import Divider from '../Divider.jsx';
const { makeStyles } = styles;

const CardActions = props => {
  const classes = useStyles();
  return (
    <div className={classNames(classes.root, props.className)}>
      <Divider />
      <div className={classes.content}>
        {props.children}
      </div>
    </div>
  );
};

CardActions.propTypes = {
  children: PropTypes.any,
};

const useStyles = makeStyles(
  (theme) => ({
    root: {
      width: '100%',
      paddingTop: theme.spacing(2),
    },
    content: {
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'flex-start',
      alignItems: 'center',
    },
  })
);

export default CardActions;
